import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    footer: {
        display: 'inline-block',
        left: 'auto',
        right: 0,
        bottom: 0,
        width: '100%',
        height: '60px',
        position: 'fixed',
        backgroundColor: '#FFF',
        color: '#000',
        zIndex: 9999,
        boxShadow:
            '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
        transition: theme.transitions.create(['margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        })
    },
    leftSide: {
        margin: '20px 0px 0 98px',
        color: '#666666',
        '& h6': {
            fontFamily: 'OpenSans, sans-serif !important'
        },
        width: '50%'
    },
    leftSideFull: {
        marginTop: '20px',
        color: '#666666',
        '& h6': {
            fontFamily: 'OpenSans, sans-serif !important'
        },
        width: '100%'
    },
    rightSide: {
        width: '50%',
        marginTop: '20px',
        marginRight: '50px',
        textAlign: 'right',
        '& h6': {
            fontFamily: 'OpenSans, sans-serif !important'
        }
    },
    termsMenu: {
        display: 'inline-flex',
        width: '100vw'
    },
    rightSideLink: {
        textDecoration: 'none',
        color: '#666666',
        marginRight: '7%',
        display: 'inline-block'
    },
    alignCenter: {
        textAlign: 'center'
    }
}));
